export function init_payment() {

    const SELECT_METHOD = document.querySelector('.mollie-form').firstElementChild;
    const SELECT_ISSUER = document.querySelector('.mollie-form').lastElementChild;

    SELECT_METHOD.addEventListener("change", checkValue);

    SELECT_METHOD.insertAdjacentHTML('afterend', '<div class="mobile-dropdown-arrow first">▼</div>');
    SELECT_ISSUER.insertAdjacentHTML('afterend', '<div class="mobile-dropdown-arrow second">▼</div>');

    function checkValue() {

        if(SELECT_METHOD.value == "ideal") {
            SELECT_ISSUER.classList.add('show');
            SELECT_ISSUER.classList.remove('hide');
        } else if (SELECT_METHOD.value != "ideal"){
            SELECT_ISSUER.classList.remove('show');
            SELECT_ISSUER.classList.add('hide');
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/payment.js